import React from "react";

const Skills = () => {
  return (
    <React.Fragment>
      <h3 className="title-font white-text ">
        Some of my skills related to volleyball and my life 
      </h3>
      <ol className="skill-section">
        <li>Problem Creating</li>
        <li>Serving</li>
        <li>Passing</li>
        <li>Setting</li>
        <li>Attacking</li>
        <li>Digging</li>
        <li>Problem Solving</li>

     
      </ol>
    </React.Fragment>
  );
};

export default Skills;
